import LegalPageLayout from "@/components/LegalPageLayout";
import {
  COMPANY_ADDRESS_FULL,
  COMPANY_CIF,
  COMPANY_CONTACT_EMAIL,
  COMPANY_LEGAL_NAME,
} from "@/lib/company";

const PoliticaCookies = () => {
  return (
    <LegalPageLayout title="Política de Cookies">
            <p className="text-gray-600 mb-6">
              Última actualización: {new Date().toLocaleDateString("es-ES")}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. ¿Qué son las Cookies?</h2>
              <p className="text-gray-700 mb-4">
                Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (ordenador, 
                tablet o móvil) cuando visitas un sitio web. Estas cookies permiten que el sitio web 
                recuerde tus acciones y preferencias durante un período de tiempo.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Tipos de Cookies que Utilizamos</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.1 Cookies Técnicas (Necesarias)</h3>
              <p className="text-gray-700 mb-4">
                Estas cookies son esenciales para el funcionamiento del sitio web y no se pueden desactivar. 
                Incluyen:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Cookies de sesión para mantener tu sesión activa</li>
                <li>Cookies de seguridad para proteger contra ataques</li>
                <li>Cookies de preferencias de idioma</li>
                <li>Cookies de aceptación de cookies</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.2 Cookies de Rendimiento</h3>
              <p className="text-gray-700 mb-4">
                Nos ayudan a entender cómo interactúas con el sitio web recopilando información anónima:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Páginas más visitadas</li>
                <li>Tiempo de permanencia en el sitio</li>
                <li>Errores que pueden ocurrir</li>
                <li>Rendimiento del sitio web</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.3 Cookies de Funcionalidad</h3>
              <p className="text-gray-700 mb-4">
                Permiten que el sitio web recuerde las elecciones que haces para proporcionarte 
                una experiencia más personalizada:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Preferencias de idioma</li>
                <li>Configuración de la región</li>
                <li>Preferencias de accesibilidad</li>
                <li>Información de inicio de sesión</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">2.4 Cookies de Marketing</h3>
              <p className="text-gray-700 mb-4">
                Se utilizan para rastrear visitantes en sitios web para mostrar anuncios relevantes 
                y atractivos para el usuario individual:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Análisis de comportamiento de navegación</li>
                <li>Publicidad personalizada</li>
                <li>Medición de efectividad de campañas</li>
                <li>Redes sociales y contenido externo</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Cookies de Terceros</h2>
              <p className="text-gray-700 mb-4">
                Utilizamos servicios de terceros que pueden instalar cookies en tu dispositivo:
              </p>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1 Google Analytics</h3>
              <p className="text-gray-700 mb-4">
                Utilizamos Google Analytics para analizar el uso del sitio web. Google Analytics 
                utiliza cookies para recopilar información sobre cómo utilizas nuestro sitio web.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.2 Redes Sociales</h3>
              <p className="text-gray-700 mb-4">
                Los botones de redes sociales pueden instalar cookies para rastrear tu actividad 
                en redes sociales.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.3 Servicios de Pago</h3>
              <p className="text-gray-700 mb-4">
                Nuestros proveedores de servicios de pago pueden instalar cookies para procesar 
                transacciones de forma segura.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Duración de las Cookies</h2>
              <p className="text-gray-700 mb-4">
                Las cookies pueden tener diferentes duraciones:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li><strong>Cookies de sesión:</strong> Se eliminan cuando cierras el navegador</li>
                <li><strong>Cookies persistentes:</strong> Permanecen en tu dispositivo durante un período específico</li>
                <li><strong>Cookies de terceros:</strong> Su duración depende de la política del proveedor</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Gestión de Cookies</h2>
              <p className="text-gray-700 mb-4">
                Puedes gestionar las cookies de varias maneras:
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.1 Configuración del Navegador</h3>
              <p className="text-gray-700 mb-4">
                Puedes configurar tu navegador para rechazar todas las cookies o para recibir 
                una notificación cuando se envíe una cookie. Sin embargo, si rechazas las cookies, 
                es posible que algunas partes de nuestro sitio web no funcionen correctamente.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.2 Panel de Control de Cookies</h3>
              <p className="text-gray-700 mb-4">
                Utilizamos un panel de control de cookies que te permite gestionar tus preferencias 
                de cookies de forma granular.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.3 Enlaces de Opt-out</h3>
              <p className="text-gray-700 mb-4">
                Para cookies de terceros, puedes optar por no participar visitando los sitios web 
                de los proveedores correspondientes.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Cookies Específicas que Utilizamos</h2>
              
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border border-gray-300 px-4 py-2 text-left">Nombre</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Propósito</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Duración</th>
                      <th className="border border-gray-300 px-4 py-2 text-left">Tipo</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">session_id</td>
                      <td className="border border-gray-300 px-4 py-2">Mantener sesión de usuario</td>
                      <td className="border border-gray-300 px-4 py-2">Sesión</td>
                      <td className="border border-gray-300 px-4 py-2">Técnica</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">cookie_consent</td>
                      <td className="border border-gray-300 px-4 py-2">Recordar preferencias de cookies</td>
                      <td className="border border-gray-300 px-4 py-2">1 año</td>
                      <td className="border border-gray-300 px-4 py-2">Técnica</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">_ga</td>
                      <td className="border border-gray-300 px-4 py-2">Google Analytics - Identificación de usuario</td>
                      <td className="border border-gray-300 px-4 py-2">2 años</td>
                      <td className="border border-gray-300 px-4 py-2">Analítica</td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-2">_gid</td>
                      <td className="border border-gray-300 px-4 py-2">Google Analytics - Identificación de sesión</td>
                      <td className="border border-gray-300 px-4 py-2">24 horas</td>
                      <td className="border border-gray-300 px-4 py-2">Analítica</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Actualizaciones de esta Política</h2>
              <p className="text-gray-700 mb-4">
                Nos reservamos el derecho de actualizar esta política de cookies en cualquier momento. 
                Los cambios se publicarán en esta página con la fecha de última actualización. 
                Te recomendamos revisar periódicamente esta política.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contacto</h2>
              <p className="text-gray-700 mb-4">
                Si tienes alguna pregunta sobre nuestra política de cookies, puedes contactarnos en:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>
                  Email:{" "}
                  <a href={`mailto:${COMPANY_CONTACT_EMAIL}`} className="text-taxby-purple hover:text-taxby-violet hover:underline">
                    {COMPANY_CONTACT_EMAIL}
                  </a>
                </li>
                <li>Dirección: {COMPANY_ADDRESS_FULL}</li>
                <li>Razón social: {COMPANY_LEGAL_NAME}</li>
                <li>CIF: {COMPANY_CIF}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Enlaces Útiles</h2>
              <p className="text-gray-700 mb-4">
                Para más información sobre cookies y cómo gestionarlas:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>
                  <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer" className="text-taxby-purple hover:text-taxby-violet hover:underline">
                    All About Cookies
                  </a>
                </li>
                <li>
                  <a href="https://www.youronlinechoices.com" target="_blank" rel="noopener noreferrer" className="text-taxby-purple hover:text-taxby-violet hover:underline">
                    Your Online Choices
                  </a>
                </li>
                <li>
                  <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-taxby-purple hover:text-taxby-violet hover:underline">
                    Agencia Española de Protección de Datos
                  </a>
                </li>
              </ul>
            </section>
    </LegalPageLayout>
  );
};

export default PoliticaCookies; 